export class EcrDefinitionsInfo {
    /**Codice ECR */
    code: string;

    /**Codice ECR parent */
    parentCode: string;

    /**Modello dispositivo (nomenclatura CIMA) */
    model: string;

    /**Modello dispositivo (nomenclatura usata per la certificazione) */
    certModel: string;

    /**Modello sensore di riconoscimento */
    sensorHw: string;

    /**Software sensore di riconoscimento */
    sensorSw: string;

    /**Categoria dispositivo */
    deviceCategory: string;

    /**Data del test per la certificazione */
    testDate: Date | string;

    /**Data di scadenza */
    expirationDate: Date | string;

    constructor() { }

    public parse(obj: any) {

        if (obj.Code)
            this.code = obj.Code;
        if (obj.ParentCode)
            this.parentCode = obj.ParentCode;
        if (obj.Model)
            this.model = obj.Model;
        if (obj.CertModel)
            this.certModel = obj.CertModel;
        if (obj.SensorHw)
            this.sensorHw = obj.SensorHw;
        if (obj.SensorSw)
            this.sensorSw = obj.SensorSw;
        if (obj.DeviceCategory)
            this.deviceCategory = obj.DeviceCategory;
        if (obj.TestDate)
            this.testDate = obj.TestDate;
        if (obj.ExpirationDate)
            this.expirationDate = obj.ExpirationDate;
    }
}